
import React from 'react';
import { Route } from 'react-router-dom';
import RoleProtectedRoute from '@/components/RoleProtectedRoute';
import Academy from '@/pages/Academy';
import AcademyDashboard from '@/pages/AcademyDashboard';

export const AcademyRoutes = () => (
  <>
    {/* Academy */}
    <Route path="/academy" element={<Academy />} />
    <Route path="/academy/dashboard" element={<AcademyDashboard />} />
    <Route path="/academy/courses" element={<Academy />} />
    <Route path="/academy/courses/:slug" element={<Academy />} />
    <Route path="/academy/assignments" element={<Academy />} />
    <Route path="/academy/certification" element={<Academy />} />

    {/* Academy Admin */}
    <Route path="/academy/admin" element={<RoleProtectedRoute allowedRoles={['admin']}><AcademyDashboard /></RoleProtectedRoute>} />
    <Route path="/academy/admin/students" element={<RoleProtectedRoute allowedRoles={['admin']}><AcademyDashboard /></RoleProtectedRoute>} />
    <Route path="/academy/admin/courses" element={<RoleProtectedRoute allowedRoles={['admin']}><AcademyDashboard /></RoleProtectedRoute>} />
    <Route path="/academy/admin/reports" element={<RoleProtectedRoute allowedRoles={['admin']}><AcademyDashboard /></RoleProtectedRoute>} />
  </>
);
